import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import * as moment from 'moment';
@Injectable({
  providedIn: 'root'
})
export class AppointmentsService {

  constructor(private firestore: AngularFirestore) {}

  public getAppointment(documentId: string) {
    return this.firestore.collection('appointments').doc(documentId).snapshotChanges();
  }

  public getAppointments() {
    return this.firestore.collection('appointments').snapshotChanges();
  }

  public createAppointment(appointment){
    delete appointment.id;
    return this.firestore.collection('appointments').add({...appointment})
  }

  public updateAppointment(appointment){
    const id = appointment.id;
    delete appointment.id;
    return this.firestore.doc('appointments/'+id).update({...appointment});
  }

  public deleteAppointment(id){
    return this.firestore.collection('appointments').doc(id).delete();
  }

  public getAppointmentsByDate(date : moment.Moment) {
    let tomorrow = moment(date).add(1, 'days');
    return this.firestore.collection(
      'appointments', ref =>
        ref.where("selectedDate", ">=", date.toDate()).
        where("selectedDate", "<", tomorrow.toDate())
    ).snapshotChanges()
  }

}
